import React, { useState, useEffect } from 'react';
import CryptoJS from 'crypto-js';
import { ENTERPRISE_ENV } from '../../utils/helper';
import { getElementBySelectorAsync } from '../ComplexDocumentDesign/complexDocumentHelper';

const PDSSupportWidget = props => {
  const [nonce, setNonce] = useState('');
  const { url } = props;
  const generateNonce = () => {
    const randomString = Math.random().toString();
    const hash = CryptoJS.MD5(randomString).toString();
    setNonce(hash)
  }
  useEffect(() => {
    generateNonce();
    const script = document.createElement('script');
    script.id = 'pdsSupportWidget';
    script.type = 'text/javascript';
    script.src = `https://desk.zoho.in/portal/api/web/asapApp/${ENTERPRISE_ENV ? '72450000003256009' : '72450000003099133'}?orgId=60014218657`;
    script.defer = true;
    script.nonce = nonce;
    document.head.appendChild(script);
    getElementBySelectorAsync('#zohohc-asap-web-helper-main').then(domNode => {
      domNode.setAttribute('data-html2canvas-ignore', true);
    })
    return () => {
      // Cleanup: Remove the script when the component unmounts
      const pdsSupportWidget = document.getElementById('pdsSupportWidget');
      if (pdsSupportWidget) {
        pdsSupportWidget.remove();
      }
    };
  }, [url]);
  return <></>;
};
export default PDSSupportWidget;
